import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loading: -1,
    updating: -1,
    estimate: -1,
  },
  data: {},
  estimate: null,
  isFinish: false,
  error: {
    estimate: null,
    updateFee: null,
  },
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;

  switch (type) {
    case ACTION_TYPES.CONSULT_PRICE_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 0,
        },
      };
    case ACTION_TYPES.CONSULT_PRICE_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.CONSULT_PRICE_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loading: 2,
        },
        error,
      };
    case ACTION_TYPES.CONSULT_FEE_ESTIMATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          estimate: 0,
        },
        error: { ...state.error, updateFee: null, estimate: null },
      };
    case ACTION_TYPES.CONSULT_FEE_ESTIMATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          estimate: 1,
        },
        error: { ...state.error, estimate: null },
        estimate: payload.data,
      };
    case ACTION_TYPES.CONSULT_FEE_ESTIMATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          estimate: 2,
        },
        error: { ...state.error, estimate: error },
      };
    case ACTION_TYPES.CONSULT_PRICE_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 0,
        },
        error: { ...state.error, estimate: null, updateFee: null },
      };
    case ACTION_TYPES.CONSULT_PRICE_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 1,
        },
        error: { ...state.error, updateFee: null },
        data: payload.data,
      };
    case ACTION_TYPES.CONSULT_PRICE_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 2,
        },
        error: { ...state.error, updateFee: error },
      };
    case ACTION_TYPES.CONSULT_PRICE_RESET:
      return {
        ...state,
        status: {
          ...initialState.status,
        },
        error: {
          ...initialState.error,
        },
      };
    default:
      return state;
  }
}
